module.exports = __webpack_public_path__ + "img/icon_time_white.bd41ca23.svg";